function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext, useMemo } from "react";
import cx from "classnames";
import omit from "just-omit";
import { twMerge } from "../../../utils";
import { LinkContext } from "../../../context";
import { Heading, LinkButton } from "../../atoms";
import { ArrowRight } from "../../icons";
export var JobListEntry = function(param) {
    var title = param.title, label = param.label, callToAction = param.callToAction, className = param.className;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var linkProps = useMemo(function() {
        return omit(callToAction, "style", "label");
    }, [
        callToAction
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge(cx("border-b border-b-fg-inbetween last-of-type:border-b-0", className))
    }, /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, linkProps, {
        className: "grid items-center grid-cols-1 gap-5 py-6 hover:text-brand-primary-base md:py-7 md:grid-cols-[4fr_1fr]"
    }), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3s"
    }, title), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(LinkButton, {
        as: "button",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
        className: "w-full text-left"
    }, label))));
};

//# sourceMappingURL=JobListEntry.js.map